module.exports = "/images/addressHome.svg";